import * as React from "react"

function SvgAlignLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path stroke="currentColor" d="M8.5 8v16" />
      <path fill="currentColor" stroke="currentColor" d="M12.5 12.5h11v2h-11zM12.5 17.5h7v2h-7z" />
    </svg>
  )
}

export default SvgAlignLeft
